import React from 'react';
import { TimerBar } from './components/TimerBar';
import { Hero } from './components/Hero';
import { TrustStrip } from './components/TrustStrip';
import { TopTestimonials } from './components/TopTestimonials';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { VolumesSection } from './components/VolumesSection';
import { ForYouSection } from './components/ForYouSection';
import { BonusesSection } from './components/BonusesSection';
import { ValueTable } from './components/ValueTable';
import { PricingSection } from './components/PricingSection';
import { BottomTestimonials } from './components/BottomTestimonials';
import { ComparisonSection } from './components/ComparisonSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { SiteFooter } from './components/SiteFooter';
export function App() {
  return <div className="min-h-full w-full bg-ink-950 font-sans text-white" data-id="element-0" data-mp="3iiwdwl3utc1n">
      <TimerBar data-id="element-1" data-mp="3mlayb9n68jv1" />
      <Hero data-id="element-2" data-mp="3mkrbpfmkt7ao" />
      <TrustStrip data-id="element-3" data-mp="3mkhofzsx1e8o" />
      <main data-id="element-4" data-mp="3mjq1fdddwou0">
        <TopTestimonials data-id="element-5" data-mp="3mjg7xft4rzjk" />
        <PainSection data-id="element-6" data-mp="3rcj6k2crlz6m" />
        <SolutionSection data-id="element-7" data-mp="3rbzngibdp4r0" />
        <VolumesSection data-id="element-8" data-mp="3rcswjpxt86cb" />
        <ForYouSection data-id="element-9" data-mp="3relumgucxi8p" />
        <BonusesSection data-id="element-10" data-mp="5opiv1o0k3w" />
        <ValueTable data-id="element-11" data-mp="4wx1t3d72hu" />
        <PricingSection data-id="element-12" data-mp="5gbv0xpxarn" />
        <BottomTestimonials data-id="element-13" data-mp="7st1bvnjh3n" />
        <ComparisonSection data-id="element-14" data-mp="2zllcouynw8jk" />
        <GuaranteeSection data-id="element-15" data-mp="2zmenc70qri6z" />
        <FaqSection data-id="element-16" data-mp="2zn6bwxvx8fnr" />
        <FinalCta data-id="element-17" data-mp="33morde4z3yj7" />
      </main>
      <SiteFooter data-id="element-18" data-mp="33nq5xsl7735o" />
    </div>;
}